module.exports = require("graphql");


//////////////////
// WEBPACK FOOTER
// external "graphql"
// module id = 23
// module chunks = 0